export default {
  dreamCodeHero: {
    label: 'PROGRAM',
    title: 'DREAM CODE',
    subtitle: '从结构设计成长的教育框架',
  },
  whyChange: {
    label: 'WHY CHANGE',
    title: '为什么人能改变？',
    body1: '许多人希望"改变"但改变无法持续的原因，不是意志薄弱，而是"结构"。',
    body2: '思考产生行动，行动产生结果。\n然而，这些思考和行动受到过去经验形成的认知模式的影响。',
    highlight: 'DREAM CODE是一个可视化并重新设计无意识结构的教育过程。\n目标不是暂时的兴奋，而是可重现的改变。',
  },
  cycle: {
    label: 'CYCLE STRUCTURE',
    title: '确立变化的\n4阶段循环设计',
    stage1: { number: '01', title: '基础形成', subtitle: '自我理解与结构认识', desc: '客观审视自己的思维模式和行为倾向，明确无意识的前提。' },
    stage2: { number: '02', title: '重构', subtitle: '思维回路的重新设计', desc: '通过反复实践与内省，形成新的认知模式。' },
    stage3: { number: '03', title: '未来设计', subtitle: '战略愿景的构建', desc: '将具体的未来蓝图落实为可执行的行动计划。' },
    stage4: { number: '04', title: '自主成长', subtitle: '建立可持续的成长机制', desc: '转变为循环学习、自主成长的状态。' },
    centerLabel: 'CYCLE',
    centerText: '循环设计',
    footer: '学习、体验、反思、确立。\n这种循环创造持续的变化。',
  },
  scientific: {
    label: 'SCIENTIFIC BASIS',
    title: '基于科学知识的教育设计',
    keyword1: '神经可塑性',
    keyword2: '赫布定律',
    keyword3: '认知行为理论',
    keyword4: '自我效能理论',
    body1: 'DREAM CODE不依赖于单一特定理论。',
    body2: '它从神经可塑性、赫布定律、认知行为理论、自我效能理论等多个学术发现中获得教育设计的启示。',
    body3: '它不主张思想直接改变物理现象。\n然而，正如众多研究所表明的，思想会影响注意力、选择与行动。',
    conclusion1: '如果结构改变，\n行动就会改变。',
    conclusion2: '如果行动改变，\n结果就会改变。',
    conclusion3: '我们将这一链条设计为教育。',
  },
  integration: {
    label: 'INTEGRATION',
    title: '改变结构，未来就会改变。',
    body1: '改变并非偶然。',
    body2: '通过理解原理、经由体验加以确立，可重现的成长便由此诞生。',
    body3: 'DREAM CODE是揭示这一结构的教育框架。',
  },
  cta: {
    button1: '考虑个人参与',
    button2: '咨询实施事宜',
  },
  fourFields: {
    label: 'FOUR FIELDS',
    title: '从四个学术视角の整合',
    philosophy: {
      label: '成功哲学',
      labelEn: 'SUCCESS PHILOSOPHY',
      goal: '培养目标：成功脑（现实与真实脑）',
      goalEn: 'Architectural Intelligence',
      description: '成功哲学是整理成果的思维原理领域。基于历史思想家与现代研究，聚焦于"产生结果的思维方式"。它着眼于原理性的成功，而非情感理论。',
    },
    brain: {
      label: '基礎脳科学',
      labelEn: 'BRAIN SCIENCE',
      goal: '培养目标：人格脑（重复脑、会话脑、领导脑）',
      goalEn: 'Character Intelligence',
      description: '神经可塑性与赫布定律表明，神经回路通过经验与重复得到强化。DREAM CODE将重复与内省相结合，促进新思维回路的形成。',
    },
    psychology: {
      label: '行为心理学',
      labelEn: 'BEHAVIORAL PSYCHOLOGY',
      goal: '培养目标：忍耐脑（被愛脑、人間関係脑）',
      goalEn: 'Relational Intelligence',
      description: '认知行为理论认为，决定行动的不是事件本身，而是对事件的"解读"。信念影响选择，选择引导结果。这一领域专注于行动层面的结构设计。',
    },
    quantum: {
      label: '基础量子力学',
      labelEn: 'QUANTUM MECHANICS',
      goal: '培养目标：情感脑（情感経営脑、目標達成脑、資産形成脑）',
      goalEn: 'Emotional Intelligence',
      description: '量子力学是研究物理现象的学科，并不直接解释人类愿望的实现。然而，"观测"、"不确定性"、"可能性"等概念，为重新审视现实的认知结构提供了视角。DREAM CODE将这些内容作为哲学与概念框架加以运用。',
    },
    courses: {
      '01': { title: '现实与真实法则', subtitle: '梦想实现100%！想象与选择理論' },
      '02': { title: '梦想实现法则', subtitle: '成功法则3原則理論' },
      '03': { title: '自我形象法则', subtitle: '自我形象完成理論' },
      '04': { title: '心理控制論法则', subtitle: '目標追求装置理論' },
      '05': { title: '信念法则', subtitle: '4位偉人共同の信念理論' },
      '06': { title: '思维定勢法则', subtitle: '安慰剂与反安慰剂效应理論' },
      '07': { title: '胜者与败者の5个法则', subtitle: '胜者与败者の习惯脑回路理论' },
      '08': { title: '实践信念培养5阶段法则', subtitle: '信念完全掌握理論' },
      '09': { title: '显意识与潜意识法则', subtitle: '显意识×潜意识×RAS理論' },
      '10': { title: '认真法则', subtitle: '苏格ラ底哲学理論' },
      '11': { title: '范式转换法则', subtitle: '摆脱自我中心理論' },
      '12': { title: '实践·禁止事项法则', subtitle: '日常生活适应6項理論' },
      '13': { title: '怯场解放法则', subtitle: '脳神経細胞信号伝導理論' },
      '14': { title: '自我奖励神经群法则', subtitle: '马斯洛需求层次理论' },
      '15': { title: '10000小时法则', subtitle: '通过反复练习培养脑回路理論' },
      '16': { title: '3大神经递质法则', subtitle: '必不可少の化学物质理論' },
      '17': { title: '7種力量（实力）法则', subtitle: '培养成功脑回路の4段階理論' },
      '18': { title: '沟通法则', subtitle: '终极会話術理論' },
      '19': { title: '5段階反驳処理法则', subtitle: '投诉処理法理論' },
      '20': { title: '脑内化学物质法则', subtitle: '賭博与恋愛処理理論' },
      '21': { title: '3原則信任獲得法则', subtitle: '终极下属培养理論' },
      '22': { title: '最强組織培养构建法则', subtitle: '终极組織培养術理論' },
      '23': { title: '压力控制法则', subtitle: '压力処理法理論' },
      '24': { title: '全責任法则', subtitle: '禁止理論' },
      '25': { title: '爱の4段階法则', subtitle: '人格形成4原則理論' },
      '26': { title: '"被愛脑回路"法则', subtitle: '渴望被認証·渴望被愛理論' },
      '27': { title: '本能欲求与意图欲求法则', subtitle: '专业与业余理論' },
      '28': { title: '终极动力法则', subtitle: '如何产生并激发动力理論' },
      '29': { title: '恐惧·愤怒法则', subtitle: '自我解放理論' },
      '30': { title: '终极黄金律法则', subtitle: '给予原則理論' },
      '31': { title: '终极決断法则', subtitle: '选择自由理論' },
      '32': { title: '成功价值观法则', subtitle: '以終为始理論' },
      '33': { title: '伟人秘伝法则', subtitle: '3歳·8歳·18歳理論' },
      '34': { title: '破窗理論法则', subtitle: '心身関係理論' },
      '35': { title: '从他人依赖脑脱离法则', subtitle: '自我确立脑回路培养理論' },
      '36': { title: '認知症改善脑回路法则', subtitle: 'Center方式脑回路培养理論' },
      '37': { title: '量子医学法则', subtitle: '科学×哲学×波动共鸣×人类意识×AI解析理論' },
      '38': { title: '波动共鸣法则', subtitle: '喜悦·祈祷·感恩脑回路理論' },
      '39': { title: '量子場法则', subtitle: 'Royal Raymond Rife博士癌細胞除去射線機理論' },
      '40': { title: '量子医学×波动×AI法则', subtitle: '未来医疗理論' },
      '41': { title: '創造性销售法法则', subtitle: '营销脑回路培养理论' },
      '42': { title: '成功脑回路培养4段階法则', subtitle: '運動脑·健康脑回路培养理論' },
      '43': { title: '波动宣言×AI法则', subtitle: '肯定理論' },
      '44': { title: '波动视频×AI法则', subtitle: '可视化理论' },
      '45': { title: '金钱哲学3个法则', subtitle: '大富豪实践1 储蓄理論' },
      '46': { title: '資産形成10倍増法则', subtitle: '資産形成3原則理論' },
      '47': { title: '時間=金钱=労力法则', subtitle: '浪費·消費·投資理論' },
      '48': { title: '永続成功给予法则', subtitle: '全人格形成理論' },
    },
  },
};